import ProfileDisclaimerTab from './ProfileDisclaimerTab'

export default ProfileDisclaimerTab
